// utils/googlemaps-config.js
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

// Configure the loader with your API key
setOptions({
    apiKey: "AIzaSyCLEIJBahJsIhbaPQS5O-5GH-FB_hLSE-8",//process.env.VUE_APP_GOOGLE_MAPS_API_KEY || process.env.VUE_APP_GOOGLE_API_KEY,
    version: 'weekly',
    // Only use valid library names
    libraries: ['places', 'geometry', 'drawing', 'visualization', 'marker']
});

// Loader object that matches your component's expectation
const googleMapsLoader = {
    load: async () => {
        try {
            // Load required libraries using valid names only
            // 'maps' library contains Map class
            const maps = await importLibrary('maps');
            
            // 'marker' library contains Marker class  
            const marker = await importLibrary('marker');
            
            // 'core' library contains Polygon, LatLng, LatLngBounds, etc.
            const core = await importLibrary('core');
            
            // Load other libraries your app might need
            const drawing = await importLibrary('drawing');
            const visualization = await importLibrary('visualization');
            const geometry = await importLibrary('geometry');
            const places = await importLibrary('places');
            
            // Ensure google.maps object exists
            if (!window.google) window.google = {};
            if (!window.google.maps) window.google.maps = {};
            
            // Assign all loaded libraries to google.maps
            Object.assign(window.google.maps, maps);
            Object.assign(window.google.maps, marker);
            Object.assign(window.google.maps, core);
            Object.assign(window.google.maps, drawing);
            Object.assign(window.google.maps, visualization);
            Object.assign(window.google.maps, geometry);
            Object.assign(window.google.maps, places);
            
            // Explicitly assign commonly used classes
            window.google.maps.Map = maps.Map;
            window.google.maps.Marker = marker.Marker;
            window.google.maps.Polygon = core.Polygon;  // Polygon comes from core library
            window.google.maps.LatLng = core.LatLng;
            window.google.maps.LatLngBounds = core.LatLngBounds;
            window.google.maps.Point = core.Point;
            window.google.maps.Size = core.Size;
            
            // Add event listener functionality if needed
            window.google.maps.event = {
                addListener: (instance, eventName, handler) => {
                    return instance.addListener(eventName, handler);
                },
                removeListener: (listener) => {
                    if (listener && listener.remove) listener.remove();
                }
            };
            
            console.log('✅ Google Maps loaded successfully');
            return Promise.resolve();
        } catch (error) {
            console.error('❌ Failed to load Google Maps:', error);
            throw error;
        }
    }
};

export default googleMapsLoader;